import { Injectable } from '@angular/core';
import { BaseRequestService } from '@outlaw/core';
import { Observable } from 'rxjs';
import { HttpParams } from '@angular/common/http';
import { PostAccess } from '../../interfaces';

@Injectable({ providedIn: 'root' })
export class PaymentService extends BaseRequestService {
  paymentUrl = '/payments-api';

  checkPostAccess(postUUID: string): Observable<PostAccess> {
    return this.http.get<PostAccess>(`${this.paymentUrl}/access_controls/client/access/${postUUID}/check_access/`);
  }

  checkAccessToken(): Observable<any> {
    return this.http.get(`${this.paymentUrl}/external/check_access_token/`);
  }

  getProductOffers(productUUID: string): Observable<any> {
    let httpParams = new HttpParams();
    httpParams = httpParams.append('project_slug', 'community');
    httpParams = httpParams.append('products_uuid', productUUID);
    return this.http.get(`${this.paymentUrl}/offers/client/offer/by_product/`, {
      params: httpParams,
    });
  }
}
